import { useEffect, useRef } from "react";
import { useLocation } from "react-router";

import { analytics } from "~/analytics";

export const usePageView = () => {
  const location = useLocation();
  const last = useRef("");

  useEffect(() => {
    if (last.current !== window.location.href) {
      analytics.page({ name: window.location.href });
    }
    last.current = window.location.href;
  }, [location]);
};
